export const DS_CHECKBOX_CLASSES = {
  Root: "ds-checkbox",
  Input: "ds-checkbox__input",
} as const;
